import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AccessRightEnum } from '../../../../../../../enum/AccessRightEnum';
import { IPlatformSummary } from '../../../../../../../model/measure/IMeasure';
import { getSocialIcons } from '../../../../../../../shared/functions/Functions';
import { IAllStates } from '../../../../../../../store/rootReducer';
import { priceSplitter } from '../../../../../../../utils/helpers/priceSplitter';
import { Row } from 'react-bootstrap';
import CardLayout from '../../../../../../../shared/components/card/CardLayout';

interface ICampaignPlatformProps {
    platformSummary?: IPlatformSummary;
}

export const CampaignSummarySocialNetworks = ({ platformSummary }: ICampaignPlatformProps) => {
    const { t } = useTranslation();
    const { accessRights } = useSelector((state: IAllStates) => state.auth.user);
    const hideCosts = accessRights.includes(AccessRightEnum.MEASURE_HIDE_COSTS);
    const { campaign } = useSelector((state: IAllStates) => state.selectedCampaign);

    return (
        <Row>
            <div className="col-md-6 mb-3 mb-md-0">
                <CardLayout classCard="h-100">
                    <h6>{t('brand.campaign.measure.overview')}</h6>
                    <div className="row mb-4" style={{ rowGap: '8px' }}>
                        <div className="col">
                            <div className="text-center text-md-start">
                                <h4 className="text-primary mb-0">
                                    {platformSummary?.completedReports ?? 0}/ {platformSummary?.reports ?? 0}
                                </h4>
                                <p className="m-0">{t('brand.campaign.measure.completedReports')}</p>
                            </div>
                        </div>
                        <div className="col px-0">
                            <div className="text-center text-md-start">
                                <h4 className="text-primary mb-0">{platformSummary?.totalInfluencers ?? 0}</h4>
                                <p className="m-0"> {t('brand.campaign.measure.totalInfluencers')}</p>
                            </div>
                        </div>
                        {!campaign?.isTransparentPricing && (
                            <div className="col px-0">
                                <div className="text-center text-md-start">
                                    <h4 className="text-primary mb-0">{platformSummary?.totalPlatforms ?? 0}</h4>
                                    <p className="m-0">{t('brand.campaign.measure.platforms')}</p>
                                </div>
                            </div>
                        )}
                        {!hideCosts && (
                            <div className="col px-0">
                                <div className="text-center text-md-start">
                                    <h4 className="text-primary mb-0 euro-symbol">
                                        {campaign?.isTransparentPricing
                                            ? priceSplitter(
                                                  platformSummary?.bookedContent ? platformSummary?.bookedContent : 0
                                              )
                                            : priceSplitter(platformSummary?.totalPrice ?? 0)}
                                    </h4>
                                    {campaign?.isTransparentPricing ? (
                                        <p className="m-0">{t('brand.campaign.measure.influencerPosting')}</p>
                                    ) : (
                                        <p className="m-0">{t('brand.campaign.measure.booked')}</p>
                                    )}
                                </div>
                            </div>
                        )}
                        {campaign?.isTransparentPricing && !hideCosts && (
                            <div className="col">
                                <div className="text-center text-md-start">
                                    <h4 className="text-primary mb-0 euro-symbol">
                                        {priceSplitter(platformSummary?.transparentBudget ?? 0)}
                                    </h4>
                                    <p className="m-0">{t('brand.campaign.measure.transparentTotal')}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </CardLayout>
            </div>
            <div className="col-md-6 mb-3 mb-md-0">
                <CardLayout classCard="h-100">
                    <h6>{t('brand.campaign.measure.placements')}</h6>
                    <div className="d-flex flex-wrap justify-content-between justify-content-lg-start">
                        {platformSummary?.platforms.map((platform: any, i: number) => {
                            return (
                                <div className="w-md-25 mb-4" key={`${platform.socialPlatform.name}-${i}`}>
                                    {getSocialIcons({
                                        iconPath: platform.socialPlatform.path,
                                        dataTop: `x${platform.totalPosts}`,
                                        dataDown: t(`general.platforms.${platform.socialPlatform.name}`),
                                        colorText: 'primary',
                                    })}
                                </div>
                            );
                        })}
                    </div>
                </CardLayout>
            </div>
        </Row>
    );
};
